<!--
 * @Author: lijiahui
 * @Date: 2021-01-12 15:57:58
 * @LastEditTime: 2022-08-02 11:15:52
 * @LastEditors: xuhuining
 * @Description: 育儿日历组件
-->
<template>
  <div class="parentingCalen">
    <!-- swiper形式 -->
    <div class="swiperCalen" v-show="swiperOrflow">
      <!-- <div class="father-div"> -->
        <div class="swiper-container container_content">
        <div class="swiper-wrapper" id='content_wrapper'>
          <div class="swiper-slide" v-for="(item,index) in swiperCalendarList" :key="item.id">
            <div class="slide_list">
              <div :class="slidesNum==1.2?'img_box2':'img_box'" @click="enlargeImg(true,item)">
                <img :src="item.imgUrl" alt="">
                <div class="magnify" v-show="magnifyIndex == index">
                  <img class="magnifyImage" src="../../../assets/images/icon/magnify.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-prevcontent"></div>
        <div class="swiper-button-nextcontent"></div>
      <!-- </div> -->
      </div>

      <div class="show-numbers" v-if="pages.totalElements > 0 && pages.currentPage > 0">{{pages.currentPage}} / {{pages.totalElements}}</div>
    </div>
    <operationBlock v-show="swiperOrflow" :curItem='curItemObj' :ABtest='ABtest' @weShare='weShare'></operationBlock>
    <!-- 数据为空提示 -->
    <emptyList v-show="emptyShow"></emptyList>
    <!-- 育儿日历签到成功弹窗 -->
    <calenSign v-if="signToastShow" :signData='signData' @getSignData='getSignData'></calenSign>
    <!-- 育儿日历图片放大 -->
    <calenImg v-if="enlargeImgShow" :ABtest='ABtest' :enlargeImgItem='enlargeImgItem' @enlargeImg='enlargeImg' @weShare='weShare'></calenImg>
    <!-- loading加载中 -->
    <div class="load_mask" v-show="loadingShow">
      <img src="../../../assets/images/loading.gif" alt="">
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
// 空数据提示组件
import emptyList from '@/components/contents/emptyList.vue'
// 育儿日历签到成功弹窗
import calenSign from "@/components/contents/calendar/calenSign.vue"
// 育儿日历图片放大
import calenImg from "@/components/contents/calendar/calenImg.vue"
// 育儿日历图片放大
import operationBlock from "@/components/contents/calendar/operationBlock.vue"
import { Debounce} from '@/assets/js/common.js'
import API from '@/utils/axiosApi/calendarApi'
export default {
  name: 'calendar',
  components: {
    emptyList, calenSign, calenImg, operationBlock
  },
  props: {
    ABtest: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      magnifyIndex:0,//当前图片的下标
      UserInfo: null, // 用户信息
      swiperOrflow: true, // 当前显示是swiper日历还是瀑布流
      signState: false,  // 签到状态
      totalDays: 0, // 连续签到天速
      // 瀑布流日历
      // flowParams: {
      //   type: 2, monthDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1)
      // },
      // flowCalendarList: [],
      // swiper日历
      swiperParams: {
        type: 1, page: 1, size: 10, dayDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
      },
      isSwiperPage: true,
      swiperCalendarList: [],
      // 头部时间swiper数组
      flowTimeArry: [],
      swiperTimeArry: [],
      // swiper组件
      swiperTitle: null,
      swiperContent: null,
      // 到底提示
      finiText: false,
      // 数据为空提示
      emptyShow: false,

      signData: null,   //签到弹窗数据
      signToastShow: false,  // 签到成功弹窗显示
      enlargeImgItem: null,  // 当前要放大日历的数据对象
      enlargeImgShow: false,
      loadingShow: false,
      swiperActive: 0,
      jinShow: false, // 今按钮显示状态
      slidesNum: 1.33,
      curItemObj: null,
      // 最后一条数据
      finData: '',
      // 倒数第二条数据鼠标位置记录
      mousePoi: 0,
      switchMenuState: true,
      sensorsFlag: true, // 埋点
      pages:{
        currentPage:0, //当前页数
        totalElements:0, //总条数
      },
    }
  },
  mounted () {
    document.getElementsByClassName('parentingCalen')[0].style.minHeight = (window.innerHeight - 54) + 'px';
    this.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.getCalendarList(1);
    if (window.innerHeight > 667) {
      this.slidesNum = 1.348;
    }
  },
  watch:{
    // 监听当前的选中的index值 计算条数  第一页（最后一页）隐藏 前进按钮（后退按钮）
    magnifyIndex(val){
      this.pages.currentPage = this.pages.totalElements - (this.swiperParams.size* (this.swiperParams.page-1) - (val+1))
      if(this.pages.totalElements - this.pages.currentPage === 1 ){
        document.getElementsByClassName("swiper-button-nextcontent")[0].style.display = "none"
      }else{
        if(this.pages.currentPage === 1){
          document.getElementsByClassName("swiper-button-prevcontent")[0].style.display = "none"
        }else{
          document.getElementsByClassName("swiper-button-prevcontent")[0].style.display = "block"
          document.getElementsByClassName("swiper-button-nextcontent")[0].style.display = "block"
        }
      }
    }
  },
  methods: {
    // 获取日历列表
    getCalendarList: Debounce(function (type) {
      this.switchMenuState = false;
      const params = type == 1 ? this.swiperParams : this.flowParams;
      params.crmId = this.UserInfo ? this.UserInfo.crm_id : '';
      API.getCalendarList({}, params, res => {
        if (res.code == '200') {
          if (type == 1) {
            const { page, content, size, totalElements } = res.data;
            const dataArry = content;
            this.finData = page == 1 ? dataArry.shift() : this.finData;
            dataArry.forEach((item, index) => {
              this.swiperTimeArry.unshift(item.startDate);
              this.swiperCalendarList.unshift(item);
            });
            this.pages.totalElements = totalElements
            if (totalElements == 0 || this.swiperParams.page >= Math.ceil(totalElements / this.swiperParams.size)) {
              this.isSwiperPage = false;
            } else {
              this.isSwiperPage = true; //继续加载
              this.swiperParams.page += 1;
            }
            const _this = this;
            this.$nextTick(() => {
              if (page == 1) {
                _this.initSwiperContent();
                this.handleFinalImg('add');
              } else {
                _this.swiperContent.update(false);
                this.handleFinalImg('update')
                setTimeout(() => {
                  const slidePisition = content.length + _this.swiperActive;
                  _this.swiperContent.slideTo(slidePisition, 0, false);
                }, 10)
              }
              setTimeout(function () {
                _this.loadingShow = false;
              }, 800)
            })
          } else {
            const dataArry = res.data;
            this.flowCalendarList = dataArry;
            this.finiText = true; //  到底提示
            if (this.flowCalendarList.length == 0) {
              this.emptyShow = true;
            } else {
              this.emptyShow = false;
            }
          }
          if (this.sensorsFlag) {
            this.sensorsFlag = false
            sensors.track('Parenting_program_PV_UV', { 'Column': '育儿日历', })
          }
        }
        this.switchMenuState = true;
      })
    }, 500),
    /**
     * swiper图片处理
     * @param contentWrapper dom添加外层
     * @param swiperSlide 取值dom
     * @param img 生成dom
     */
    handleAddImg (contentWrapper, swiperSlide, img) {
      img.src = this.finData.imgUrl;
      img.style.width = swiperSlide.offsetWidth + 'px';
      img.style.height = swiperSlide.offsetHeight + 'px';
      img.style.display = 'block';
      img.style.transform = 'scale(0.93)';
      img.style.flexShrink = '0';
      img.className = 'addNode';
      contentWrapper.append(img);
    },
    /**
     * 删除dom
     * @param contentWrapper dom添加外层
     * @param className 删除样式名
     */
    handleRemoveToClass (contentWrapper, className) {
      const nodes = contentWrapper.childNodes;
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].className === className) {
          contentWrapper.removeChild(nodes[i])
        }
      }
    },

    /**
     * 最后一张图放置
     * @param type add: 添加   remove:删除  update:更新
     */
    handleFinalImg (type) {
      const img = document.createElement('img');
      const swiperSlide = document.querySelector('.container_content #content_wrapper .swiper-slide');
      const contentWrapper = document.querySelector('.container_content #content_wrapper');
      if (type === 'add') {
        this.handleAddImg(contentWrapper, swiperSlide, img)
      } else if (type === 'remove') {
        this.handleRemoveToClass(contentWrapper, 'addNode')
      } else if (type === 'update') {
        this.handleRemoveToClass(contentWrapper, 'addNode')
        this.handleAddImg(contentWrapper, swiperSlide, img);
      }
    },
    initSwiperContent () {
      var _this = this;
      this.swiperContent = new Swiper('.container_content', {
        initialSlide: this.swiperTimeArry.length - 1,
        slidesPerView: _this.slidesNum,
        navigation: {
          nextEl: ".swiper-button-nextcontent",
          prevEl: ".swiper-button-prevcontent",
        },
        spaceBetween: 0,
        centeredSlides: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        on: {
          slideChange: function (){
            // if(_this.swiperContent.activeIndex >= this.swiperTimeArry.length - 2) {
            // this.swiperContent.allowSlideNext = false;
            // } else {
            // this.swiperContent.allowSlideNext = true;
            // }
          },
          slideNextTransitionEnd: function () {
            _this.slidePrevTransitionEnd(this.activeIndex);
            _this.$emit('weShare',_this.curItemObj.id)
            _this.magnifyIndex = this.activeIndex
          },
          slidePrevTransitionEnd: function () {
            _this.slidePrevTransitionEnd(this.activeIndex);
            _this.$emit('weShare',_this.curItemObj.id)
            _this.magnifyIndex = this.activeIndex
          },
          touchStart: function (event) {
            this.mousePoi = event.changedTouches[0].pageX;
          },
          touchEnd: function (event) {
            var endPoi = event.changedTouches[0].pageX;
            if (this.isEnd && endPoi - this.mousePoi < -100) {
              _this.$toast({
                message: "最后一页啦！明天见～",
                forbidClick: true,
                duration: 2000,
                context: this
              });
            }
          }
        }
      });
      this.$nextTick(() => {


        var wh = $(window).height()//页面的高度
        var ot = $(".slide_list").offset().top//是标签距离顶部高度
        var ds =  $(document.documentElement).scrollTop();//滚动的高度
        var icoimg_h = $(".slide_list").height();//是标签高度
        var pages = $(".show-numbers").height(); //页数高度
        var bh = wh - icoimg_h - [ot -ds];
        if (document.getElementsByClassName('swiperCalen')[0].style.paddingTop == '') {
          // var paddingTop = (window.innerHeight - 100 - document.getElementsByClassName('swiperCalen')[0].clientHeight + 56) / 2 + 22;
          // var childTop = document.getElementsByClassName('van-tabs__wrap')[0].clientHeight;
          // var Top = $(".container_title_box").height();
          // if (paddingTop <= childTop) {
          //   paddingTop = childTop + 12;
          // }
          document.getElementsByClassName('swiperCalen')[0].style.paddingTop = (wh - 107 - icoimg_h - pages)/2  + "px";
        }
      })
    },
    /**
     * 瀑布流形式切换时间时改变数据
     * @param activeIndex 当前点击swiper的index
     */
    slidePrevTransitionEnd (activeIndex) {
      console.log(activeIndex)
      if (!this.swiperOrflow) { // 瀑布流形式
        this.flowCalendarList = [];
        this.flowParams.monthDate = this.flowTimeArry[activeIndex];
        this.getCalendarList(2);
      } else {
        console.log("*****" + activeIndex,this.swiperParams.page)
        if (activeIndex == 0 && this.isSwiperPage) {
          this.loadingShow = true;
          this.getCalendarList(1);
        }
        if(this.swiperParams.page > 2){
          const index = ((this.swiperParams.page - 2 ) * 10 -2) + (10 - activeIndex)
          this.curItemObj = this.swiperCalendarList[index];
        }else{
          this.curItemObj = this.swiperCalendarList[activeIndex];
        }
          console.log(33339,this.curItemObj)
      }
    },
    /**
     * 育儿日历放大弹窗
     * @param flag true:显示，false:隐藏
     * @param data 放大图片的数据
     */
    enlargeImg (flag, data) {
      if(flag){
        $(".operation_block").css({'display':'none'})
      }else{
        $(".operation_block").css({'display':'block'})
      }
      this.enlargeImgShow = flag;
      this.enlargeImgItem = data;
      let that = this
      if(data){
        that.$emit('weShare',data.id)
      }
    },
    // 获取某个时间段的月份
    getYearAndMonth (start, end) {
      var result = [];
      var s = start.split("-");
      var e = end.split("-");
      var min = new Date();
      var max = new Date();
      min.setFullYear(s[0], s[1] * 1, 1);//开始日期
      max.setFullYear(e[0], e[1] * 1, 1);//结束日期
      var curr = min;
      while (curr <= max) {
        var month = curr.getMonth();
        result.push(curr.getFullYear() + "-" + this.PrefixInteger((month + 1), 2));
        curr.setMonth(month + 1);
      }
      return result;
    },
    PrefixInteger (num, length) {
      return (num / Math.pow(10, length)).toFixed(length).substr(2);
    },
    weShare (id) {
      this.$emit('weShare', id)
    }
  }
}
</script>

<style lang="less" scoped>
@import './../../../assets/less/contents/calendar/parentingCalen.less';
.swiper-slide {
  transition: unset !important;
}
</style>
